import PerconaMigrator from './PerconaMigrator';

export default PerconaMigrator;
